// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config from "../Config.bs.js";
import * as Caml_option from "../../node_modules/rescript/lib/es6/caml_option.js";
import * as Icon$Catalyst from "../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as ButtonUtils$Catalyst from "../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";

function getViewMoreButtonProps(cb, href, textOpt, param) {
  var text = textOpt !== undefined ? textOpt : "View More";
  return ButtonUtils$Catalyst.getDefaultButtonProps({
              TAG: /* Href */2,
              _0: text,
              _1: href
            }, undefined, (function (param) {
                return Curry._1(cb, undefined);
              }), undefined, Caml_option.some(React.createElement(Icon$Catalyst.NavigateIcon.make, {
                      fontSize: "Default"
                    })), undefined, undefined, undefined, undefined, undefined);
}

function getCrmUrl(url) {
  var baseUrl = Config.Env.getCrmBaseUrl(undefined);
  var path = List.fold_left((function (a, b) {
          return a + ("/" + b);
        }), "", url.path);
  var search = url.search !== "" ? "?" + url.search : "";
  var hash = url.hash !== "" ? "#" + url.hash : "";
  return baseUrl + (path + (search + hash));
}

function getCrmUrlWithoutHash(url) {
  var baseUrl = Config.Env.getCrmBaseUrl(undefined);
  var path = List.fold_left((function (a, b) {
          return a + ("/" + b);
        }), "", url.path);
  var search = url.search !== "" ? "?" + url.search : "";
  return baseUrl + (path + search);
}

function isURLSame(url1, url2, withoutHash) {
  if (withoutHash) {
    return getCrmUrlWithoutHash(url1) === getCrmUrlWithoutHash(url2);
  } else {
    return getCrmUrl(url1) === getCrmUrl(url2);
  }
}

function isPfeOrder(ticketing_order) {
  return ticketing_order._0.is_pfe_order;
}

export {
  getViewMoreButtonProps ,
  getCrmUrl ,
  getCrmUrlWithoutHash ,
  isURLSame ,
  isPfeOrder ,
  
}
/* react Not a pure module */
